import { GridRowSelectionModel } from '@mui/x-data-grid-premium';

/**
 * DataGrid v8 の行選択モデル(GridRowSelectionModel)を、選択済みの数値 ID 配列へ変換する。
 *
 * v8 では選択が `{ type: 'include' | 'exclude', ids: Set }` で表現される。
 * - include: ids がそのまま選択集合。個別選択も、スナックバー経由の全レコード選択
 *   (現在ページ外の ID を含む) も include で届くため、現在ページに絞らずそのまま採用する。
 * - exclude: ヘッダのチェックボックス全選択がこの形で届く(ids は選択から除外された集合)。
 *   現在ページの全 ID から除外分を引いて選択集合を算出する。
 */
export const buildSelectedIds = (
  model: GridRowSelectionModel,
  currentPageIds: number[],
): number[] => {
  const ids = Array.from(model.ids, (id) => Number(id));

  if (model.type === 'exclude') {
    const excluded = new Set(ids);
    return currentPageIds.filter((id) => !excluded.has(id));
  }

  return ids;
};
